import CheckmarkCircleBold from './CheckmarkCircleBold';

export default CheckmarkCircleBold;
